import { JSX } from 'react';
import TextBox from '../TextBox';
import { IProtectedTextBoxProperties } from './entities/IProtectedTextBoxProperties';
import { FormItemTypes } from '@bimser/core';

export default class ProtectedTextBox extends TextBox {
	dataType: number;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.ProtectedTextBox;
	}

	__loadProperties(data: IProtectedTextBoxProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.dataType = data.dataType;
	}

	__getComponentData() {
		return {
			...super.__getComponentData()
		};
	}

	__render(children?: JSX.Element) {
		return super.__render();
	}
}
